(function () {
  var cache = {};

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function decorate(card, handle) {
    var info = cache[handle];
    if (!info || info === 'pending') return;

    // Titelzusatz (Metafeld) bzw. Masse der Fertigvorhänge an den Titel hängen
    var titleEl = card.querySelector('.boost-sd__product-title');
    if (titleEl && info.size && titleEl.dataset.sizeSet !== handle) {
      titleEl.textContent = info.title + ' ' + info.size;
      titleEl.dataset.sizeSet = handle;
    }

    // Alle Produkte: Unterzeile mit dem Produkttyp
    if (titleEl && !card.querySelector('.vch-type-label')) {
      var label = document.createElement('div');
      label.className = 'vch-type-label';
      label.textContent = info.label || ' '; // leer = Platzhalter, damit alle Karten gleich hoch sind
      label.style.cssText = 'font-size:13px;color:#6b6b6b;margin-top:2px;';
      titleEl.insertAdjacentElement('afterend', label);
    }

    if (!info.isMass) return;

    // Alles nach Mass (Vorhänge, Plissees, Schienen, Stangen): "ab" vor den Preis
    var priceEl = card.querySelector('.boost-sd__product-price-content .boost-sd__format-currency');
    if (priceEl) {
      var inner = priceEl.querySelector('span') || priceEl;
      var text = inner.textContent.trim();
      if (text && text.indexOf('ab ') !== 0) {
        inner.textContent = 'ab ' + text;
        inner.style.textTransform = 'none';
        inner.style.whiteSpace = 'nowrap';
      }
    }
  }

  function decorateAll(handle) {
    document.querySelectorAll('.boost-sd__product-item').forEach(function (c) {
      if (getHandle(c) === handle) decorate(c, handle); // exakter Vergleich
    });
  }

  // Produktdaten laden: zuerst über die Vorlage product.vch-card (inkl. Titelzusatz),
  // falls die Vorlage fehlt oder nicht antwortet, wie bisher über /products/<handle>.js
  function loadProduct(handle) {
    return fetch('/products/' + handle + '?view=vch-card')
      .then(function (r) {
        if (!r.ok) throw new Error('view');
        return r.json();
      })
      .catch(function () {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
      });
  }

  // nur reine Zahlenwerte verwenden (z. B. "245" oder "245 cm"), Ausreisser wie "145 x 140 cm" ignorieren
  function sizeTag(tags, prefix) {
    return tags.find(function (t) {
      return t.indexOf(prefix) === 0 && /^\d+([.,]\d+)?\s*(cm)?$/i.test(t.replace(prefix, '').trim());
    });
  }
  function cleanSize(tag, prefix) {
    return tag.replace(prefix, '').replace(/cm/i, '').trim();
  }

  // Einordnung des Produkts.
  // WICHTIG: gleiche Regeln wie im Theme-Snippet snippets/vch-product-label.liquid.
  // Wenn hier etwas geändert wird, dort ebenfalls anpassen.
  function classify(d) {
    var tags = d.tags || [];
    var hasTag = function (t) { return tags.indexOf(t) !== -1; };

    var isSchiene = hasTag('Vorhangschiene');
    var isStange = hasTag('Vorhangstange');
    var isSystem = isSchiene || isStange;
    var isPlissee = !isSystem && (hasTag('Plissee') || /^(Waben)?plissee/i.test(d.title || ''));
    var isRollo = !isSystem && !isPlissee && /Rollo/i.test(d.type || '');
    var isZubehoer = !isSystem && !isPlissee && !isRollo && (hasTag('Zubehör') || d.type === 'Vorhang Zubehör');

    var hasWidth = tags.some(function (t) { return t.indexOf('width:') === 0; });
    var hasFertigTag = tags.some(function (t) { return t.indexOf('Fertigvorhang') === 0 || t.indexOf('mit Faltenband') !== -1; });

    // Schienen/Stangen haben ebenfalls Lieferzeit-Tags wie "2 - 5 Wochen",
    // deshalb werden sie (und Plissees/Zubehör) vorher ausgeschlossen.
    var isMass = !isSystem && !isPlissee && !isRollo && !isZubehoer && !hasFertigTag && (
      d.type === 'Stoff' ||
      tags.some(function (t) { return t.indexOf('Massvorhang') === 0 || /^\d+ - \d+ Wochen$/.test(t); })
    );
    var isFertig = !isSystem && !isPlissee && !isRollo && !isZubehoer && !isMass && (hasFertigTag || hasWidth);

    var typeLabels = { 'Rollo / Plissée': 'Rollo' };
    var label = isSchiene ? 'Vorhangschiene nach Mass'
              : isStange ? 'Vorhangstange nach Mass'
              : isPlissee ? 'Plissee nach Mass'
              : isRollo ? 'Rollo'
              : isZubehoer ? 'Zubehör'
              : isMass ? 'Vorhang nach Mass'
              : isFertig ? 'Fertigvorhang'
              : (typeLabels[d.type] || d.type || '');

    return {
      label: label,
      isFertig: isFertig,
      konfigurierbar: isMass || isPlissee || isSystem
    };
  }

  function processCard(card) {
    var handle = getHandle(card);
    if (!handle) return;

    if (cache[handle] !== undefined) {
      decorate(card, handle);
      return;
    }

    cache[handle] = 'pending';
    loadProduct(handle)
      .then(function (d) {
        var tags = d.tags || [];
        var hTag = sizeTag(tags, 'height:');
        var wTag = sizeTag(tags, 'width:');
        var c = classify(d);

        // 1) Titelzusatz aus dem Metafeld hat Vorrang (z. B. Zubehör "Maxi 6.2–6.6 mm")
        // 2) sonst bei Fertigvorhängen die Masse aus den height:/width:-Tags
        var suffix = String(d.title_suffix || '').trim();
        var size = suffix || ((c.isFertig && hTag && wTag) ? cleanSize(hTag, 'height:') + 'x' + cleanSize(wTag, 'width:') : null);

        cache[handle] = {
          title: d.title,
          size: size,
          isMass: c.konfigurierbar, // Preis mit "ab" bei allem, was nach Mass konfiguriert wird
          label: d.label || c.label // falls die Vorlage vch-card ein fertiges Label liefert, hat es Vorrang
        };
        decorateAll(handle);
      })
      .catch(function () { cache[handle] = null; });
  }

  // Kollektionsseiten (Theme-Kacheln): "ab" vor den Preis bei Massvorhängen
  function decorateThemeCard(card) {
    var type = card.querySelector('.product-type');
    var AB_LABELS = ['Vorhang nach Mass', 'Plissee nach Mass', 'Vorhangschiene nach Mass', 'Vorhangstange nach Mass'];
    if (!type || AB_LABELS.indexOf(type.textContent.trim()) === -1) return;
    var priceEl = card.querySelector('.product-thumbnail__price');
    if (!priceEl) return;
    // Boost-Kollektionskacheln setzen das "ab" bereits selbst (boost-pfs-filter.js, <small><em>)
    if (priceEl.querySelector('small em')) return;
    var money = priceEl.querySelector('.money');
    if (!money) return;
    var text = money.textContent.trim();
    if (text && text.indexOf('ab ') !== 0) money.textContent = 'ab ' + text;
  }

  var CARD_SELECTOR = '.boost-sd__product-item, .product__grid-item';

  function processAll() {
    document.querySelectorAll('.boost-sd__product-item').forEach(processCard);
    document.querySelectorAll('.product__grid-item').forEach(decorateThemeCard);
  }

  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes, function (n) {
        return n.nodeType === 1 &&
          ((n.matches && n.matches(CARD_SELECTOR)) ||
           (n.querySelector && n.querySelector(CARD_SELECTOR)));
      });
    });
    if (hasNewCards) processAll();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  processAll();
})();